/**
 * <ParentSessionGestures> — les surfaces des gestes partagés, montées par les deux écrans.
 *
 * Câblage seul : il n'a aucun état, aucune copie. Il étale les props que
 * `useParentSessionGesture` a construites sur les six surfaces du design system, pour que
 * l'accueil et « Tous mes lives » montent EXACTEMENT les mêmes — un geste qui gagne une étape
 * la gagne des deux côtés, sans qu'on y pense.
 *
 * Son `<Snackbar>` est la SEULE fente d'accusé de l'écran : deux bandeaux au même décalage
 * s'écrivaient l'un sur l'autre (même règle que `ActivityOverlays`). Un autre geste de l'écran
 * — le rattrapage de l'accueil — passe le sien en `screenNotice` ; celui des gestes gagne tant
 * qu'il est à l'écran.
 *
 * Le composeur de message n'est pas ici : il appartient à `useLiveSessionsListState`, qui le
 * possède déjà pour le menu. « Quel tuteur ? » lui désigne le destinataire et lui passe son
 * retour : le composeur en devient la 2ᵉ étape, sous le même en-tête.
 */
import React from "react"

import {
    ConfirmDialog,
    MoveSessionFlow,
    ReportLateFlow,
    Snackbar,
    TutorPickerModal,
} from "../../../../../../design-system"
import { type SnackbarProps } from "../../../../../../design-system/molecules/Snackbar"
import { type ParentSessionGesturesProps } from "../../../hooks/useParentSessionGesture"

export type ParentSessionGesturesOverlaysProps = ParentSessionGesturesProps & {
    /** L'accusé d'un autre geste de l'écran, quand il en produit un. */
    screenNotice?: SnackbarProps | null
}

export function ParentSessionGestures(props: ParentSessionGesturesOverlaysProps) {
    const { move, late, tutorPicker, joinConfirm, paymentConfirm, notice, screenNotice } = props

    return (
        <>
            <MoveSessionFlow {...move} />
            <ReportLateFlow {...late} />
            <TutorPickerModal {...tutorPicker} />
            <ConfirmDialog {...joinConfirm} />
            <ConfirmDialog {...paymentConfirm} />
            <Snackbar {...(notice.visible || screenNotice == null ? notice : screenNotice)} />
        </>
    )
}

export default ParentSessionGestures
